//@ts-nocheck

function getStyleSheet() {
  var selector = ['.error_widget',
    'ace-tm',
    'ace_editor.css',
    'ace-github',
    '.react-datepicker-popper',
    '.emoji-picker-react',
    'prism.js',
    '.ui-component .button-group,.ui-component button'
  ]
  const filterCheck = (sheet) => {
    const ownerNode = sheet.ownerNode;
    return !(selector.includes(ownerNode.id) || selector.some(s => ownerNode.innerHTML.includes(s)))
  }
  let styleSheets = '';
  Array.from(document.styleSheets).filter(filterCheck).forEach((sheet: CSSStyleSheet) => {
    //@ts-ignore
    styleSheets += sheet.ownerNode.outerHTML;
  })
  return styleSheets;
}
export async function handleExtensionModal(configs) {
  const { iframeRef, postRobot, getExtraProps } = window;
  if (!(iframeRef && postRobot)) return;
  const { isOpen } = configs;
  if (isOpen) {
    let payload = {
      dom: iframeRef.outerHTML,
    }
    if (!window.isStyleSend) {
      payload.styles = getStyleSheet()
    }
    if (typeof getExtraProps === 'function') {
      payload = { ...payload, ...getExtraProps() }
    }
    await postRobot.sendToParent('DOMCopy', payload);
    const alreadyFullscreen = iframeRef.querySelector('#scrte-editor')?.classList.contains('fullscreen');
    if (!alreadyFullscreen)
      iframeRef.style.opacity = 0;
    await postRobot.sendToParent('goFullscreen', {
      open: true
    });
    window.isStyleSend = true
  }
}